// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Footer section  */
.footer {
  position: relative;
  bottom: 0;
  background-color: #202020;
  opacity: 90%;
  width: 100%;
  color: white;
  flex-direction: column;
  text-align: center;
  padding: 2rem;
}


.footer .footer-contact-info .footer-heading {
  font-size: 5rem;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin-bottom: 10px;
}

.footer .footer-contact-info .footer-contact-access {
  font-size: 2rem;
  padding-top: 10px;
  letter-spacing: .2rem;
  margin-bottom: -0.1rem;
}

.footer .social-icons a {
  color: white;
  font-size: 3rem;
  display: inline-block;
}

/* End Footer section  */`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;;;AAGA;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA,wBAAwB","sourcesContent":["/* Footer section  */\n.footer {\n  position: relative;\n  bottom: 0;\n  background-color: #202020;\n  opacity: 90%;\n  width: 100%;\n  color: white;\n  flex-direction: column;\n  text-align: center;\n  padding: 2rem;\n}\n\n\n.footer .footer-contact-info .footer-heading {\n  font-size: 5rem;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  margin-bottom: 10px;\n}\n\n.footer .footer-contact-info .footer-contact-access {\n  font-size: 2rem;\n  padding-top: 10px;\n  letter-spacing: .2rem;\n  margin-bottom: -0.1rem;\n}\n\n.footer .social-icons a {\n  color: white;\n  font-size: 3rem;\n  display: inline-block;\n}\n\n/* End Footer section  */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
